import * as React from "react";
import "./ToggleSwitch.scss";

interface ToggleSwitchProps {
  leftLabel: string;
  leftDisabled?: boolean;
  rightLabel: string;
  rightDisabled?: boolean;
  onSwitch: (selectedOption: SelectedOption) => void;
  optionSelected: SelectedOption;
}

export enum SelectedOption {
  LEFT,
  RIGHT,
  NONE,
}

export default function ToggleSwitch({
  leftLabel,
  rightLabel,
  onSwitch,
  optionSelected,
  rightDisabled,
  leftDisabled,
}: ToggleSwitchProps) {
  return (
    <div className="toggle-switch">
      <button
        className={
          leftDisabled
            ? "disabled"
            : optionSelected === SelectedOption.LEFT
              ? "selected"
              : "clickable"
        }
        onClick={() => !leftDisabled && onSwitch(SelectedOption.RIGHT)}
      >
        {leftLabel}
      </button>
      <button
        className={
          rightDisabled
            ? "disabled"
            : optionSelected === SelectedOption.RIGHT
              ? "selected"
              : "clickable"
        }
        onClick={() => !rightDisabled && onSwitch(SelectedOption.LEFT)}
      >
        {rightLabel}
      </button>
    </div>
  );
}
